import { useQuery } from 'wasp/client/operations'
import { getPersonalizedRecipesV2 } from 'wasp/client/operations'

type Options = {
  limit?: number
  offset?: number
  mealType?: string
  forceRefresh?: boolean
  insightMode?: 'basic' | 'full'
}

export function usePersonalizedRecipesV2(options: Options = {}) {
  const { data, isLoading, error, refetch } = useQuery(getPersonalizedRecipesV2, options, {
    enabled: true,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
  })
  return {
    recipes: data ?? [],
    isLoading,
    error,
    refetch,
  }
}
